import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import GlobalReset from './theme/reset';
import IndexRoute from './routes';
import GlobalFonts from './theme/globalFonts';
import GlobalStyle from './theme/globalStyle';

const App = (): React.ReactElement => {
  return (
    <BrowserRouter>
      <GlobalReset />
      <GlobalFonts />
      <GlobalStyle />
      <IndexRoute />
    </BrowserRouter>
  );
};

export default App;
